import {ERROR_TYPE} from './consts';

export const validateExpiryMonthAndYear = value => {
    if (!value) {
        return ERROR_TYPE.required;
    }

    const [expiryYear, expiryMonth] = value.split('/');

    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
    const selectedYear = parseInt(expiryYear, 10);
    const selectedMonth = parseInt(expiryMonth, 10);

    if (currentYear > selectedYear || (currentYear === selectedYear && selectedMonth < currentMonth)) {
        return ERROR_TYPE.notInFuture;
    }

    return '';
};
